"use client";

import { AdminChatAccountType } from "@/app/admin/chat/types";
import { User } from "@/types";
import type { Session } from "next-auth";
import {
	createContext,
	Dispatch,
	ReactNode,
	SetStateAction,
	useContext,
	useMemo,
	useState,
} from "react";

type Context = {
	data: User;
	accountId: string;
	account: [AdminChatAccountType, Dispatch<SetStateAction<AdminChatAccountType>>];
	hasSupportAccount: boolean;
};

export const ChatContext = createContext<Context | undefined>(undefined);

export function useChatContext(): Context {
	const context = useContext(ChatContext);
	if (!context) {
		throw new Error('useChatContext must be used within a ChatContextProvider');
	}
	return context;
}

export function ChatContextProvider({
	children,
	session,
}: {
	children: ReactNode;
	session: Session;
}) {
	const [account, setAccount] = useState<AdminChatAccountType>("support");
	
	const accountId = useMemo(
		() => session.user.id,
		[session.user.id],
	);

	const data = useMemo(
		() => ({
			...session.user,
			_id: session.user.id,
			firstName: "Client",
			lastName: "Support",
			email: "support@techxeed.com",
			avatar: "/Main Icon.jpg",
			companyName: "Techxeed",
		}),
		[session.user],
	);

	return (
		<ChatContext.Provider value={{ data, accountId, account: [account, setAccount], hasSupportAccount: true }}>
			{children}
		</ChatContext.Provider>
	);
}

export function ChatDummyContextProvider({
	session,
	children,
}: Pick<Parameters<typeof ChatContextProvider>[0], "session" | "children">) {
	return (
		<ChatContext.Provider
			value={{
				data: { ...session.user, _id: session.user.id },
				account: ["current", () => {}],
				accountId: session.user.id,
				hasSupportAccount: false,
			}}
		>
			{children}
		</ChatContext.Provider>
	);
}
